
import { Switch, Form, Input, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from 'react-i18next';

const attachmentsFormats = [
    { label: 'Images (JPG, PNG, GIF, etc.)', value: 'images' },
    { label: 'PDF', value: 'pdf' },
    { label: 'Word Documents (DOC/DOCX)', value: 'doc' },
    { label: 'Excel Spreadsheets (XLS/XLSX)', value: 'xls' },
    { label: 'PowerPoint (PPT/PPTX)', value: 'pptx' },
    { label: 'CSV Files', value: 'csv' },
]

const AttachmentForm = ({ formValues, form }) => {
    const { t } = useTranslation();
    
    return (
        <>
            <Form.Item name="label" label={t('Label')}>
                <Input placeholder={t('Enter label')} />
            </Form.Item>

            <Form.Item name="tooltip" label={t('Tooltip')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            {
                formValues && formValues.tooltip &&
                <Form.Item label="" name="helpText">
                    <TextArea rows={2} placeholder={t('Enter help text')} />
                </Form.Item>
            }

            <Form.Item name="mandatory" label={t('Mandatory')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="readOnly" label={t('Read Only')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="hideInitially" label={t('Hide Initially')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="multipleAttachments" label={t('Multiple attachments allowed')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            <Form.Item name="attachmentFormat" label={t('Formats allowed')}>
                <Select mode="multiple" options={attachmentsFormats.map(f => ({ ...f, label: t(f.label) }))} placeholder={t('Select formats')} />
            </Form.Item>
            
        </>
    )
}

export default AttachmentForm